export default [
    {
        name: "Silvella",
        birth: 2022,
        height: "-",
        movies: [],
        pictures: ["SILVELLA_12.jpg", "SILVELLA_8.jpg", "SILVELLA_9.jpg", "SILVELLA_10.jpg", "SILVELLA_11.jpg", "SILVELLA_1.jpg", "SILVELLA_2.jpg", "SILVELLA_3.jpg", "SILVELLA_4.jpg", "SILVELLA_5.jpg", "SILVELLA_6.jpg", "SILVELLA_7.jpg"],
        cover: "SILVELLA_8.jpg",
        thumb: "SILVELLA_thumb.jpg",
        sex: "Mare",
        tree: "Silvella_tree.svg",
        slug: "silvella",
        sport: "-",
    },
    {
        name: "Clove Z",
        birth: 2022,
        height: "-",
        movies: [
          "https://www.instagram.com/reel/C8Y48vqM_Np/?igsh=MWpyNzEydnJiYWJ2aw==",
          "https://www.instagram.com/reel/C-2ssj8M1wj/?igsh=Yzdmcm90djIzMWcx"
        ],
        pictures: ["CLOVE_Z_10.jpg", "CLOVE_Z_6.jpg", "CLOVE_Z_7.jpg", "CLOVE_Z_8.jpg", "CLOVE_Z_9.jpg", "CLOVE_Z_1.jpg", "CLOVE_Z_2.jpg", "CLOVE_Z_3.jpg", "CLOVE_Z_4.jpg", "CLOVE_Z_5.jpg"],
        cover: "CLOVE_Z_7.jpg",
        thumb: "CLOVE_Z_thumb.jpg",
        sex: "Mare",
        tree: "Clove_Z_tree.svg",
        slug: "clove-z",
        sport: "-",
    },
    {
        name: "Undefeated",
        birth: 2023,
        height: "-",
        movies: [
          "https://www.instagram.com/reel/DTkSxUYjJEI/?igsh=M2dvanE4OTNqaDg="
        ],
        pictures: ["UNDEFEATED_4.jpg", "UNDEFEATED_5.jpg", "UNDEFEATED_1.jpg", "UNDEFEATED_2.jpg", "UNDEFEATED_3.jpg"],
        cover: "UNDEFEATED_6.jpg",
        thumb: "UNDEFEATED_thumb.jpg",
        sex: "Gelding",
        tree: "Undefeated_tree.svg",
        slug: "undefeated",
        sport: "-",
    },
    {
        name: "Carat18",
        birth: 2024,
        height: "-",
        movies: [
          "https://www.instagram.com/reel/DOs0fjwjItn/?igsh=MWo4enk3c3F5ZDVhdQ==",
          "https://www.instagram.com/reel/DT7Z_TejGMA/?igsh=a2tqYnB0NGJ3dXQ1",
          "https://www.instagram.com/reel/DCfC7JWMRLV/?igsh=ajJ5YjZ5eTh2aTZv"
        ],
        pictures: ["CARAT18_1.jpg", "CARAT18_2.jpg", "CARAT18_3.jpg"],
        cover: "CARAT18_1.jpg",
        thumb: "CARAT18_thumb.jpg",
        sex: "Gelding",
        tree: "Carat18_tree.svg",
        slug: "carat18",
        sport: "-",
    },
    {
        name: "Cheef",
        birth: 2024,
        height: "-",
        movies: [],
        pictures: ["CHEEF_1.jpg", "CHEEF_2.jpg"],
        cover: "CHEEF_1.jpg",
        thumb: "CHEEF_thumb.jpg",
        sex: "Stallion",
        tree: "Cheef_tree.svg",
        slug: "cheef",
        sport: "-",
    },
    {
        name: "CrystalClear",
        birth: 2024,
        height: "-",
        movies: [],
        pictures: ["CRYSTALCLEAR_2.jpg", "CRYSTALCLEAR_1.jpg"],
        cover: "CRYSTALCLEAR_3.jpg",
        thumb: "CRYSTALCLEAR_thumb.jpg",
        sex: "Mare",
        tree: "CrystalClear_tree.svg",
        slug: "crystalclear",
        sport: "-",
    },
    {
        name: "Billionaire",
        birth: 2025,
        height: "-",
        movies: [],
        pictures: ["BILLIONAIRE_3.jpg", "BILLIONAIRE_1.jpg", "BILLIONAIRE_2.jpg"],
        cover: "BILLIONAIRE_1.jpg",
        thumb: "BILLIONAIRE_thumb.jpg",
        sex: "Stallion",
        tree: "Billionaire_tree.svg",
        slug: "billionaire",
        sport: "-",
    },
    {
        name: "Cherimoya",
        birth: 2025,
        height: "-",
        movies: [],
        pictures: ["CHERIMOYA_1.jpg", "CHERIMOYA_2.jpg"],
        cover: "CHERIMOYA_1.jpg",
        thumb: "CHERIMOYA_thumb.jpg",
        sex: "Mare",
        tree: "Cherimoya_tree.svg",
        slug: "cherimoya",
        sport: "-",
    },
    {
        name: "Understated Elegance",
        birth: 2025,
        height: "-",
        movies: [],
        pictures: ["UNDERSTATED_ELEGANCE_0.jpg", "UNDERSTATED_ELEGANCE_1.jpg", "UNDERSTATED_ELEGANCE_2.jpg", "UNDERSTATED_ELEGANCE_3.jpg", "UNDERSTATED_ELEGANCE_4.jpg", "UNDERSTATED_ELEGANCE_5.jpg"],
        cover: "UNDERSTATED_ELEGANCE_1.jpg",
        thumb: "UNDERSTATED_ELEGANCE_thumb.jpg",
        sex: "Mare",
        tree: "Understated_Elegance_tree.svg",
        slug: "understated-elegance",
        sport: "-",
    },
].map((horse) => ({
    ...horse,
    filter: 'youngsters'
}))
